/*************************************************************************
* Copyright (c) 2025 Omnineura AI Technologies Pvt Limited.
* All rights reserved.
* This code is licensed under the 'Omnineura AI License' found in the LICENSE file.
* Unauthorized copying, sharing, or use of this code is prohibited.
* The intellectual and technical concepts are proprietary to Omnineura AI Technologies Pvt Limited.
* Author: surya@Omnineura.ai
* Date: 11-09-2025
*************************************************************************/

import React from "react";
 
const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center space-y-4 animate-bounce">
        <div className="w-16 h-16 border-4 border-blue-600 border-dashed rounded-full animate-spin"></div>
        <p className="text-gray-700 text-lg font-semibold">Loading RAG Studio...</p>
      </div>
    </div>
  );
};
 
export default Loader;